import { render } from "./TracePlate.vue?vue&type=template&id=fef94d80&scoped=true&ts=true"
import script from "./TracePlate.vue?vue&type=script&lang=ts"
export * from "./TracePlate.vue?vue&type=script&lang=ts"

import "./TracePlate.vue?vue&type=style&index=0&id=fef94d80&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef94d80"]])

export default __exports__